export const enum FrameEnum {
  frame = 'frame',
  noFrame = 'noFrame',
}
